(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lm-ubicacion"] && !Shopify.designMode) return;
  try {
    
  if (!window.__lmLocationZoomInstalled) {
    window.__lmLocationZoomInstalled = true;

    const supportsHover = window.matchMedia(
      '(hover: hover) and (pointer: fine)'
    );

    document.addEventListener('pointermove', function(event) {
      if (!supportsHover.matches || event.pointerType === 'touch') return;
      if (!(event.target instanceof Element)) return;

      const zoom = event.target.closest('.lm-location__zoom');
      if (!zoom) return;

      const bounds = zoom.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;

      const x = Math.max(
        0,
        Math.min(100, (event.clientX - bounds.left) / bounds.width * 100)
      );

      const y = Math.max(
        0,
        Math.min(100, (event.clientY - bounds.top) / bounds.height * 100)
      );

      zoom.style.setProperty('--lm-zoom-x', x + '%');
      zoom.style.setProperty('--lm-zoom-y', y + '%');
      zoom.classList.add('is-zooming');
    }, { passive: true });

    document.addEventListener('pointerout', function(event) {
      if (!(event.target instanceof Element)) return;

      const zoom = event.target.closest('.lm-location__zoom');
      if (!zoom) return;

      if (
        event.relatedTarget instanceof Node &&
        zoom.contains(event.relatedTarget)
      ) return;

      zoom.classList.remove('is-zooming');
    });

    window.addEventListener('blur', function() {
      document.querySelectorAll('.lm-location__zoom.is-zooming')
        .forEach(function(zoom) {
          zoom.classList.remove('is-zooming');
        });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
